import React from "react";
import { Button } from "../../../../components/Buttons";
import PinInput from "../../../../components/PinInput/PinInput";

export default class ChangePin extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      pin: null
    };
  }

  onNext = () => {
    const { onComplete } = this.props;
    const { pin } = this.state;
    onComplete && onComplete({ pin });
  }

  onPinComplete = (pin) => {
    this.setState({ pin }, () => (document.querySelector(".confirm-button") as HTMLElement).focus());
  }

  onPinIncomplete = () => {
    this.setState({ pin: null });
  }

  render() {
    const { pin } = this.state;

    return (
      <div className="ChangePin">
        <div className="Settings__header">2 of 2: Change PIN</div>
        <div className="Settings__subheader">Enter your new PIN</div>
        <PinInput onComplete={this.onPinComplete} onIncomplete={this.onPinIncomplete} />
        <Button className="confirm-button" text="Confirm and complete" disabled={!pin} onClick={this.onNext} />
      </div>
    )
  }
};
